module.exports = __webpack_public_path__ + "img/trash-white.b62d8679.svg";